// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_3QOGk","hidden":"_31JZ-","overlay":"_1CRej","active":"_27HtR","poster":"_2tFRk","icon":"_13Oo9","transparency":"_1xu5m"};